/* Omnibus 30-day lowest price on app-rendered (Globo) product cards.
   The filter app re-renders the grid client-side from its own API, which
   carries no metafields, so sale cards would advertise a reduced price
   without the prior-lowest-price line that snippets/price.liquid renders
   server-side. This watches the grid for cards flagged by
   snippets/globo.filter.product.liquid (data-omnibus-pending) and hydrates
   them from the theme's ?view=omnibus JSON view. See README customization 17. */
(() => {
  const label = document.currentScript?.dataset.label || '';
  const cache = new Map();

  const fetchOmnibus = (path) => {
    if (!cache.has(path)) {
      cache.set(
        path,
        fetch(`${path}?view=omnibus`)
          .then((r) => (r.ok ? r.json() : {}))
          .catch(() => ({}))
      );
    }
    return cache.get(path);
  };

  const hydrate = (el) => {
    el.removeAttribute('data-omnibus-pending');
    let path;
    try {
      path = new URL(el.getAttribute('data-omnibus-url'), location.origin).pathname;
    } catch {
      return;
    }
    fetchOmnibus(path).then((map) => {
      const value = map[el.getAttribute('data-omnibus-variant')];
      if (!value || el.querySelector('.omnibus-lowest-price')) return;
      const line = document.createElement('div');
      line.className = 'omnibus-lowest-price omnibus-lowest-price--card';
      line.setAttribute('data-testid', 'omnibus-lowest-price');
      const labelEl = document.createElement('span');
      labelEl.className = 'omnibus-lowest-price__label';
      labelEl.textContent = `${label}:`;
      const valueEl = document.createElement('span');
      valueEl.className = 'omnibus-lowest-price__value';
      valueEl.textContent = value;
      line.append(labelEl, ' ', valueEl);
      el.appendChild(line);
    });
  };

  const sweep = () => {
    for (const el of document.querySelectorAll('[data-omnibus-pending]')) hydrate(el);
  };

  new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
  sweep();
})();
